// Array Mutation
export const updateArrayElement = (array = [], newElement, ...comparators) =>
  array.map((existingElement) =>
    comparators.every((key) => existingElement?.[key] === newElement?.[key])
      ? { ...existingElement, ...newElement }
      : existingElement
  );
